import { createWorkspaceRepository } from './workspace';
import { createTemplateRepository } from './template';
export function createPlatformReact(config) {
    const { client, repository } = config;
    const baseConfig = {
        client,
        repository,
    };
    return {
        workspace: createWorkspaceRepository(baseConfig),
        template: createTemplateRepository(baseConfig),
    };
}
//# sourceMappingURL=platformReactProvider.js.map